import { useEffect } from 'react';

import { App, Col, Result, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import Layout from 'components/Layout/Layout';

import { useAuthContext } from 'hooks/useAuthContext';

import DashboardComboChart from './components/DashboardComboChart';
import DashboardDonutChart from './components/DashboardDonutChart';
import DashboardFilters from './components/DashboardFilters';
import DashboardKpiCards from './components/DashboardKpiCards';
import DashboardTable from './components/DashboardTable';
import { useDashboardData } from './hooks/useDashboardData';
import { useDashboardFilters } from './hooks/useDashboardFilters';
import { useDashboardMetadata } from './hooks/useDashboardMetadata';

import './Dashboard.scss';

const BASE = 'scenes.kit.dashboard';

function Dashboard() {
  const { message } = App.useApp();
  const { t } = useTranslation();
  const { user } = useAuthContext();

  const metadata = useDashboardMetadata({ message });
  const dashboardData = useDashboardData({ message });
  const filters = useDashboardFilters((dateRange, campaignIds) => {
    dashboardData.fetchDashboardData(dateRange, campaignIds);
  });

  useEffect(() => {
    if (user.company.kitIntegrationEnabled) {
      dashboardData.fetchDashboardData(
        filters.dateRange,
        filters.selectedCampaignIds
      );
    }
  }, []);

  if (!user.company.kitIntegrationEnabled) {
    return (
      <Layout>
        <Result
          status="403"
          title="403"
          subTitle={t(`${BASE}.not_authorized`)}
        />
      </Layout>
    );
  }

  return (
    <Layout breadcrumbMode="none">
      <div className="kit-dashboard">
        <DashboardFilters
          filters={filters}
          campaigns={metadata.campaigns}
          metadataLoading={metadata.metadataLoading}
          loading={dashboardData.dataLoading}
          user={user}
        />

        <DashboardKpiCards
          data={dashboardData.aggregateSection}
          loading={dashboardData.dataLoading}
          user={user}
        />

        <Row gutter={[16, 16]} className="kit-dashboard__charts-row">
          <Col xs={24} lg={8}>
            <DashboardDonutChart
              data={dashboardData.turnCountByTask}
              loading={dashboardData.dataLoading}
            />
          </Col>
          <Col xs={24} lg={16}>
            <DashboardComboChart
              data={dashboardData.turnProgressByDay}
              loading={dashboardData.dataLoading}
              filterKey={filters.filterKey}
            />
          </Col>
        </Row>

        <DashboardTable
          data={dashboardData.turnSummaryStatusGrid}
          loading={dashboardData.dataLoading}
          dateRange={filters.dateRange}
          filterKey={filters.filterKey}
          touchLatamApiUrl={metadata.touchLatamApiUrl}
        />
      </div>
    </Layout>
  );
}

export default Dashboard;
